
import { Vue, Component, Prop } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import InformationWrapper from "@/components/inforationCards/InformationWrapperNew.vue";
import InformationCard from "@/components/inforationCards/InformationCardNew.vue";
import CREATE_USER_EDUCATION from "@/apollo/profile/educations/CreateEducation.gql";
import ItemChip from "@/components/common/ItemChip.vue";
import CardPagination from "@/components/card/CardPagination.vue";
import UIButton from "@/components/button/ui-button.vue";
import UiButton from "@/components/button/ui-button-message.vue";
import ChipsWithMore from "@/components/common/ChipsWithMoreResource.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import DotIcon from "@/components/icons/DotIcon.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import CollapsibleDescription from "@/components/common/CollapsibleDescriptionNew.vue";
import { NO_INFORMATION } from "@/data/placeholders";
import MailTo from "@/components/common/MailTo.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import ManagementAddContractorInfo from "@/components/contractors/ManagementAddContractorInfoResume.vue";
import AddResumeModal from "@/components/contractors/AddResumeModal.vue";
import CREATE_USER_EXPERIENCE from "@/apollo/profile/experiences/CreateExperience.gql";
import GET_LANGUAGES from "@/apollo/autocomplete-queries/GetLanguages.gql";
import moment from "moment";
import {
  User_Education,
  User_Profile_By_Management,
} from "@/generated/graphql";
import UPSER_LANGUAGES_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertLanguagesByManagement.gql";
import GET_SKILLS from "@/apollo/autocomplete-queries/GetSkills.gql";
import ItemChipsData from "@/entities/ItemChipsData";
import UPSER_SKILLS_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertSkillsByManagement.gql";
import { Contractor } from "@/interface";
import ChipWithLinkData from "@/types/ChipWithLinkData";
import UPSERT_PROFILE_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertProfileDetailsByManagement.gql";
import PhoneTo from "@/components/common/PhoneTo.vue";
import { v4 as uuid } from "uuid";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import ManageWebsite from "@/components/contractors/ManagementAddContractorInfoWebsite.vue";
import ManagePhone from "@/components/contractors/ManagementAddContractorInfoPhone.vue";
import ManageSkills from "@/components/contractors/ManagementAddContractorInfoSkills.vue";
import ManageEmail from "@/components/contractors/ManagementAddContractorInfoEmail.vue";
import ManageLanguages from "@/components/contractors/ManagementAddContractorInfoLanguages.vue";
import ManageLocation from "@/components/contractors/ManagementAddContractorInfoLocation.vue";
import ManageEducations from "@/components/contractors/ManagementAddContractorInfoEducation.vue";
import ManageExpeirence from "@/components/contractors/ManagementAddContractorInfoExpeirence.vue";
import paginationConfig from "@/data/paginationConfig";

interface Skill {
  variant: String;
  chipLink: Object;
  chipData: {
    id: Number;
    name: String;
  };
  avatar: String;
  chipText: String;
}

@Component({
  components: {
    InformationCard,
    InformationWrapper,
    ManageLanguages,
    ManageLocation,
    ManageExpeirence,
    ItemChip,
    FormGroup,
    MailTo,
    PhoneTo,
    ManagePhone,
    ManageWebsite,
    ManageEmail,
    DotIcon,
    ChipsWithMore,
    ModalFullScreen,
    CrossIcon,
    CrossIconHover,
    ManagementAddContractorInfo,
    LoadingOverlay,
    ManageSkills,
    UiButton,
    CardBodyItem,
    ManageEducations,
    CollapsibleDescription,
    AddResumeModal,
    CardPagination,
    UIButton,
  },
})
export default class ContractorDetailedInformation extends Vue {
  @Prop({ type: Object, required: true }) readonly resumeData: any;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Boolean, required: false, default: true })
  readonly isAccessGranted!: boolean;

  contractor: Contractor[] = [];
  isLoadingSkills: boolean = true;
  isLoadingLang: boolean = true;
  websiteModal: boolean = false;
  emailModal: boolean = false;
  locationModal: boolean = false;
  languagesModal: boolean = false;
  educationModal: boolean = false;
  experienceModal: boolean = false;
  phoneModal: boolean = false;
  skilllsModal: boolean = false;

  noInfo = NO_INFORMATION;
  showResume: boolean = false;
  isHovered: boolean = false;
  databaseResumeData: Object = {};
  paginationConfig: PaginationConfig = { ...paginationConfig };

  email: string = "";
  websiteToEdit: null;
  experienceToEdit: null;
  phoneToEdit: null;
  emailToEdit: null;
  educationToEdit: null;
  phone: number | undefined | string;
  country: string = "";
  state: string = "";
  city: string = "";
  profileLocation: string = "";
  occupation: string = "";
  postal_code: string = "";
  updated_at: string = "";
  website: string = "";
  work_samples: string[] = [];
  skillsIds: number[] = [];
  langIds: number[] = [];
  eduIndex: number = 0;
  isThirdModal: boolean = false;
  expIndex: number = 0;
  langName: [] = [];
  skillsData: Skill[] = [];
  langsData: Skill[] = [];
  year_of_experience: number;
  languages: string[] = [];

  created() {
    this.email = this.resumeData ? this.resumeData.emails[0] : "";
    this.phone = this.resumeData
      ? this.resumeData.phoneNumbers[0].replace(/-/g, "")
      : "";
    this.city =
      this.resumeData && this.resumeData.location
        ? this.resumeData.location.city
        : "";
    this.country =
      this.resumeData && this.resumeData.location
        ? this.resumeData.location.country
        : "";
    this.state =
      this.resumeData && this.resumeData.location
        ? this.resumeData.location.state
        : "";
    this.occupation = this.resumeData ? this.resumeData.profession : "";
    this.postal_code = this.resumeData ? this.resumeData.postal_code : "";
    this.updated_at = this.resumeData ? this.resumeData.updated_at : "";
    this.website = this.resumeData ? this.resumeData.websites[0] : "";
    this.year_of_experience = this.resumeData
      ? this.resumeData.totalYearsExperience
      : 0;
    this.languages = this.resumeData ? this.resumeData.languages : "";
    this.databaseResumeData = this.resumeData;
  }

  profilesByManagement: User_Profile_By_Management[] = [];
  processing: boolean = false;

  get contractorId_(): Object {
    return {
      contractor_id: this.contractorId,
    };
  }

  openEditModal(website) {
    this.isThirdModal = true;
    this.websiteToEdit = website ? website : "";
    this.websiteModal = true;
  }

  openEditModalPhone(phone) {
    this.isThirdModal = true;
    this.phoneToEdit = phone ? phone : "";
    this.phoneModal = true;
  }
  openSkillModal() {
    this.isThirdModal = true;
    this.skilllsModal = true;
  }
  openLanguageModal() {
    this.isThirdModal = true;
    this.languagesModal = true;
  }
  formattedStartDate(stratDate) {
    return this.formatDate(stratDate);
  }

  formattedEndDate(endDate) {
    return this.formatDate(endDate);
  }

  formatDate(dateString: string | undefined) {
    if (!dateString) {
      return "";
    }

    const date = moment(dateString);
    const finalDate = date.format("DD MMM YYYY");
    return finalDate;
  }

  openEducationModal(education, index) {
    this.eduIndex = index;
    this.isThirdModal = true;
    this.educationToEdit = education ? education : "";
    this.educationModal = true;
  }
  openExperienceModal(experience, index) {
    this.expIndex = index;
    this.isThirdModal = true;
    this.experienceToEdit = experience ? experience : "";
    this.experienceModal = true;
  }
  openEditModalEmail(email) {
    this.isThirdModal = true;
    this.emailToEdit = email ? email : "";
    this.emailModal = true;
  }
  openLocationModal() {
    this.isThirdModal = true;
    this.locationModal = true;
  }
  deleteEmail(index) {
    this.emailByManagement.splice(index, 1);
    if (this.resumeData && this.resumeData.hasOwnProperty("emails")) {
      this.resumeData.emails.splice(index, 1);
      this.$set(this.databaseResumeData, "emails", [...this.resumeData.emails]);
    }
  }
  deleteEducation(index) {
    if (this.resumeData && this.resumeData.education) {
      this.resumeData.education.splice(index, 1);
      this.$set(
        this.databaseResumeData,
        "education",
        this.resumeData.education
      );
    }
  }
  deleteExperience(index) {
    if (this.resumeData && this.resumeData.workExperience) {
      this.resumeData.workExperience.splice(index, 1);
      this.$set(
        this.databaseResumeData,
        "workExperience",
        this.resumeData.workExperience
      );
    }
  }

  deleteLocation() {
    if (this.resumeData && this.resumeData.hasOwnProperty("location")) {
      this.$set(this.resumeData, "location", {});
      this.$set(this.databaseResumeData, "location", {});
    }
  }
  deleteWebsite(index) {
    if (this.resumeData && this.resumeData.hasOwnProperty("websites")) {
      const remvoeWebsite = this.resumeData.websites.filter(
        (web) => web !== index
      );
      this.$set(this.databaseResumeData, "websites", []);
    }
  }

  deletePhone(index) {
    if (this.resumeData && this.resumeData.hasOwnProperty("phoneNumbers")) {
      const remvoePhone = this.resumeData.phoneNumbers.filter(
        (web) => web !== index
      );
      this.$set(this.databaseResumeData, "phoneNumbers", []);
    }
  }

  get secondaryItemClasses(): Record<string, boolean> {
    return {
      "py-4 border-primary-color": true,
    };
  }
  get isResumeData(): boolean {
    return Boolean(this.resumeData);
  }

  addWebsite(newWebsite) {
    if (this.resumeData && this.resumeData.hasOwnProperty("websites")) {
      this.resumeData.websites.push(newWebsite);
      this.$set(this.databaseResumeData, "websites", [
        ...this.resumeData.websites,
      ]);
    }
  }

  addEmail(newEmail) {
    if (this.resumeData && this.resumeData.hasOwnProperty("emails")) {
      this.resumeData.emails.push(newEmail);
      this.$set(this.databaseResumeData, "emails", [...this.resumeData.emails]);
    }
  }

  addPhone(newPhone) {
    if (this.resumeData && this.resumeData.hasOwnProperty("phoneNumbers")) {
      if (this.resumeData && this.resumeData.hasOwnProperty("phoneNumbers")) {
        this.resumeData.phoneNumbers.push(newPhone);
        this.$set(this.databaseResumeData, "phoneNumbers", [
          ...this.resumeData.phoneNumbers,
        ]);
      }
    }
  }

  async addlanguages(newLang) {
    this.isLoadingLang = true;
    const rawData = await this.$apollo.query({
      query: GET_LANGUAGES,
      variables: { limit: 1000 },
    });
    const updatedLangs = rawData.data.language.filter((lang) =>
      newLang.includes(lang.id)
    );
    const addObject = newLang.map((lang) => ({
      ...lang,
      variant: "green",
      chipData: {
        id: lang.id.toString(),
        name: lang.name,
      },
      avatar: "",
      chipText: "",
    }));
    this.langsData = addObject;
    this.langIds = newLang;
    this.langName = newLang;
    Vue.set(this, "langsData", addObject);
    this.isLoadingLang = false;
  }
  catch(err) {
    // console.log(err);
  }

  async addSkill(newSkills) {
    try {
      this.isLoadingSkills = true;
      const rawData = await this.$apollo.query({
        query: GET_SKILLS,
        variables: {},
      });
      const updatedSkills = rawData.data.skills_short_name_first.filter(
        (skill) => newSkills.includes(skill.id)
      );
      const addObject = updatedSkills.map((skill) => ({
        ...skill,
        variant: "green",
        chipData: {
          id: skill.id.toString(),
          name: skill.name,
        },
        avatar: "",
        chipText: "",
      }));
      this.skillsData = addObject;
      this.skillsIds = newSkills;
      Vue.set(this, "skillsData", addObject);
      this.isLoadingSkills = false;
    } catch (err) {
      // console.log(err);
    }
  }

  editLocation(updatedLoc) {
    const getEnteredValue = {
      city: updatedLoc.city,
      country: updatedLoc.country[0].name,
      state: updatedLoc.state[0].name,
      postalCode: updatedLoc.postalCode,
    };
    this.$set(this.resumeData, "location", getEnteredValue);
    this.$set(this.databaseResumeData, "location", getEnteredValue);
  }
  addLocation(updatedLoc) {
    const getEnteredValue = {
      city: updatedLoc.city,
      country: updatedLoc.country[0].name,
      state: updatedLoc.state[0].name,
      postalCode: updatedLoc.postalCode,
    };
    this.$set(this.resumeData, "location", getEnteredValue);
    this.$set(this.databaseResumeData, "location", getEnteredValue);
  }

  editWebsite(updatedWebsite) {
    if (updatedWebsite.newName.trim() === "") {
      this.resumeData.websites = [];
    } else {
      this.resumeData.websites = [updatedWebsite.newName];
    }
    this.$set(this.databaseResumeData, "websites", [
      ...this.resumeData.websites,
    ]);
  }

  editEmail(updatedEmail) {
    if (updatedEmail.newName.trim() === "") {
      this.resumeData.emails = [];
    } else {
      this.resumeData.emails = [updatedEmail.newName];
    }
    this.$set(this.databaseResumeData, "emails", [...this.resumeData.emails]);
  }

  editEducation(editedEdu) {
    const index = this.eduIndex;

    if (
      index !== -1 &&
      this.resumeData.education &&
      index < this.resumeData.education.length
    ) {
      this.$set(this.resumeData.education, index, editedEdu.newName);
      this.$set(
        this.databaseResumeData,
        "education",
        this.resumeData.education
      );
    }
  }

  editExperience(editedExp) {
    const index = this.expIndex;

    if (
      index !== -1 &&
      this.resumeData.workExperience &&
      index < this.resumeData.workExperience.length
    ) {
      this.$set(this.resumeData.workExperience, index, editedExp.newName);
      this.$set(
        this.databaseResumeData,
        "workExperience",
        this.resumeData.workExperience
      );
    }
  }

  addEducation(newEdu) {
    if (this.resumeData && this.resumeData.education) {
      this.resumeData.education.push(newEdu);
      this.$set(
        this.databaseResumeData,
        "education",
        this.resumeData.education
      );
    }
  }

  addExperience(newExp) {
    if (this.resumeData && this.resumeData.workExperience) {
      this.resumeData.workExperience.push(newExp);
      this.$set(
        this.databaseResumeData,
        "workExperience",
        this.resumeData.workExperience
      );
    }
  }

  editPhone(updatedPhone) {
    if (updatedPhone.newName.trim() === "") {
      this.resumeData.phoneNumbers = [];
    } else {
      this.resumeData.phoneNumbers = [updatedPhone.newName];
    }

    this.$set(this.databaseResumeData, "phoneNumbers", [
      ...this.resumeData.phoneNumbers,
    ]);
  }

  showEmail(email) {
    this.emailToEdit = email;
    return (this.emailModal = true);
  }

  async upsertProfileByManagement(): Promise<void> {
    this.processing = true;
    let profileByManagementSet: Partial<User_Profile_By_Management> = {
      user_id: this.contractorUserId,
      added_by_id: this.currentUserId,
      email: this.resumeData.emails ? this.resumeData.emails[0] : "",
      phone:
        this.resumeData.phoneNumbers.length > 0
          ? this.removeNonNumericChars(this.resumeData.phoneNumbers[0])
          : null,
      city: this.resumeData.location?.city
        ? this.resumeData.location?.city
        : "",
      occupation: this.occupation ? this.occupation : "",
      postal_code: this.resumeData.location?.postal_code
        ? this.resumeData.location.postal_code
          ? this.resumeData.location?.postalCode
          : this.resumeData.location?.postalCode
        : null,
      updated_at: this.updated_at ? new Date(this.updated_at) : new Date(),
      website: this.resumeData.websites ? this.resumeData.websites[0] : "",
      year_of_experience: this.year_of_experience
        ? this.year_of_experience
        : null,
      country: this.resumeData.location?.country
        ? this.resumeData.location?.country
        : "",
      state: this.resumeData.location?.state
        ? this.resumeData.location?.state
        : "",
    };
    await this.$apollo.mutate({
      mutation: UPSERT_PROFILE_BY_MANAGEMENT,
      variables: {
        userId: this.contractorUserId,
        added_by_id: this.currentUserId,
        profileByManagementSet: profileByManagementSet,
      },
    });
    await this.upsertEducation();
    await this.upsertExperience();
    await this.upsertLanguages();
    await this.upsertSkills();
    this.processing = false;
    this.$emit("refetchProfileByManagement");
    this.$emit("close");
  }

  mounted() {
    this.fetchSkillsData();
    this.fetchLangData();
  }
  get containerStyles(): string {
    return "px-6";
  }
  get cardStyles(): string {
    return "pb-4";
  }

  removeNonNumericChars(numberString) {
    return numberString.replace(/\D/g, "");
  }

  get experiencesByManagement() {
    const experiences = [];
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("workExperience") &&
      scrappedResume.workExperience &&
      scrappedResume.workExperience.length > 0
    ) {
      const workExperience = scrappedResume.workExperience;

      for (const exp of workExperience) {
        const skillId = exp?.skills?.map((s) => s.skill_id);
        let experience = {
          id: uuid(),
          user_id: this.contractorUserId,
          job_title: exp.job_title ? exp.job_title : exp.jobTitle,
          company_name: exp.company_name ? exp.company_name : exp.organization,
          employment_type: exp.employment_type ? exp.employment_type : null,
          ongoing: exp.ongoing ? true : exp.dates?.endDate ? true : false,
          location: exp.location?.rawInput
            ? exp.location.rawInput
            : exp.location,
          summary: exp.summary ? exp.summary : exp.jobDescription,
          start_date: exp.start_date ? exp.start_date : exp.dates?.startDate,
          end_date: exp.end_date ? exp.end_date : exp.dates?.endDate,
          industry_id: exp.industry_id ? exp.industry_id : null,
          added_by_id: this.currentUserId,
          created_at: new Date(),
          skills: exp.skills?.length ? exp.skills.map((skill) => skill) : [],
          user: null,
        };
        experiences.push(experience);
      }
    }
    return experiences;
  }

  get userSkills() {
    return this.skillsIds.map((skill) => ({
      user_id: this.contractorUserId,
      added_by_id: this.currentUserId,
      skill_id: skill,
    }));
  }

  get userLanguages() {
    return this.langsData.map((lan) => ({
      user_id: this.contractorUserId,
      added_by_id: this.currentUserId,
      language_id: lan.chipData.id,
    }));
  }

  async upsertEducation(): Promise<void> {
    await Promise.all(
      this.educationsByManagement.map(async (educationItem) => {
        await this.$apollo.mutate({
          mutation: CREATE_USER_EDUCATION,
          variables: {
            educationSet: educationItem,
          },
        });
      })
    );
  }

  async upsertSkills(): Promise<void> {
    this.processing = true;
    await this.$apollo.mutate({
      mutation: UPSER_SKILLS_BY_MANAGEMENT,
      variables: {
        userId: this.contractorUserId,
        added_by_id: this.currentUserId,
        skillsSet: this.userSkills,
      },
    });
  }

  async upsertExperience(): Promise<void> {
   
    await Promise.all(
      this.experiencesByManagement.map(async (experItem) => {
        await this.$apollo.mutate({
          mutation: CREATE_USER_EXPERIENCE,
          variables: {
            experienceSet: {
              ...experItem,
              industry_id: experItem.industry_id ? experItem.industry_id[0].id : null,
              skills: {
                data: experItem.skills.map((obj) => {
                  return { skill_id: obj.id };
                }),
              },
            },
          },
        });
      })
    );
  }

  async upsertLanguages(): Promise<void> {
    await Promise.all(
      this.userLanguages.map(async (langSet) => {
        await this.$apollo.mutate({
          mutation: UPSER_LANGUAGES_BY_MANAGEMENT,
          variables: {
            userId: this.contractorUserId,
            added_by_id: this.currentUserId,
            languagesSet: langSet,
          },
        });
      })
    );
  }

  async skillsIDFromResume(scrpRes) {
    const rawData = await this.$apollo.query({
      query: GET_SKILLS,
      variables: {
        where: {
          name: {
            _in: scrpRes.map((s) => s.name),
          },
        },
      },
    });
    this.skillsIds = rawData.data.skills_short_name_first
      .map((skill) => skill.id)
      .slice(0, 50);
    return rawData.data.skills_short_name_first;
  }

  async LangIDFromResume(scrpRes) {
    const rawData = await this.$apollo.query({
      query: GET_LANGUAGES,
      variables: {
        where: {
          name: {
            _in: scrpRes.map((s) => s),
          },
        },
        limit: 1000,
      },
    });
    this.langName = rawData.data.language;
    this.langIds = rawData.data.language.map((lang) => lang.id);
  }
  get skills2() {
    return this.skillsData;
  }

  get languagesByManagement() {
    return this.langsData;
  }

  async fetchLangData() {
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("languages") &&
      scrappedResume.languages &&
      scrappedResume.languages.length > 0
    ) {
      try {
        const rawData = await this.$apollo.query({
          query: GET_LANGUAGES,
          variables: {
            where: {
              name: {
                _in: scrappedResume.languages.map((s) => s),
              },
            },
            limit: 1000,
          },
        });
        this.langName = rawData.data.language.map((lang) => lang);
        const first5Lang = rawData.data.language.slice(0, 5);
        const lang = first5Lang.reduce(function (filtered, userLang) {
          let chipWithLinkData: ChipWithLinkData = {
            variant: "green",
            chipLink: {},
            chipData: {
              id: userLang.id,
              name: userLang.name,
            },
            avatar: "",
            chipText: "",
          };
          filtered.push(chipWithLinkData);
          return filtered;
        }, []);
        this.langsData = lang;
      } catch (err) {
        this.langsData = [];
      } finally {
        this.isLoadingLang = false;
      }
    }
  }
  async fetchSkillsData() {
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("skills") &&
      scrappedResume.skills
    ) {
      try {
        const rawData = await this.$apollo.query({
          query: GET_SKILLS,
          variables: {
            where: {
              name: {
                _in: scrappedResume.skills.map((s) => s.name),
              },
            },
          },
        });

        this.skillsIds = rawData.data.skills_short_name_first
          .map((skill) => skill.id)
          .slice(0, 50);

        let first50Skills = rawData.data.skills_short_name_first.slice(0, 50);
        const skills = first50Skills.reduce(function (filtered, userSkill) {
          let chipWithLinkData = {
            variant: "green",
            chipLink: {},
            chipData: {
              id: userSkill.id.toString(),
              name: userSkill.name,
            },
            avatar: "",
            chipText: "",
          };
          filtered.push(chipWithLinkData);
          return filtered;
        }, []);

        skills.sort((a, b) => a.variant.localeCompare(b.variant));
        this.skillsData = skills;
      } catch (error) {
        this.skillsData = [];
      } finally {
        this.isLoadingSkills = false;
      }
    }
  }

  get websitesByManagement(): ItemChipsData[] {
    var websites = [];
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("websites") &&
      scrappedResume.websites &&
      scrappedResume.websites.length > 0
    ) {
      websites.push({ name: this.resumeData.websites[0] });
    }
    return websites;
  }

  get emailByManagement(): ItemChipsData[] {
    var emails = [];
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("emails") &&
      scrappedResume.emails &&
      scrappedResume.emails.length > 0
    ) {
      emails.push({ name: this.resumeData.emails[0] });
    }
    return emails;
  }

  get phoneByManagement(): ItemChipsData[] {
    var phones = [];
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("phoneNumbers") &&
      scrappedResume.phoneNumbers &&
      scrappedResume.phoneNumbers.length > 0
    ) {
      phones.push({ name: this.resumeData.phoneNumbers[0] });
    }
    return phones;
  }

  get locationByManagement(): ItemChipsData[] {
    var location = [];
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("location") &&
      scrappedResume.location
    ) {
      const { city, state, country, postalCode } = scrappedResume.location;
      const allValuesNull = !city && !state && !country && !postalCode;
      if (!allValuesNull) {
        const locationObject = {
          id: this.contractorId,
          city: city?.trim() !== "" ? city : null,
          state: state?.trim() !== "" ? state : null,
          country: country?.trim() !== "" ? country : null,
          postalCode: postalCode?.trim() !== "" ? postalCode : null,
        };
        const allValuesEmpty = Object.values(locationObject).every(
          (value) => value === "" || value === null
        );
        if (!allValuesEmpty) {
          location.push(locationObject);
        } else {
          location.push(null);
        }
      }
    }
    return location.length ? location : [];
  }

  get educationsByManagement() {

    const educations = [];
    const scrappedResume = this.resumeData;
    if (
      scrappedResume &&
      scrappedResume.hasOwnProperty("education") &&
      scrappedResume.education &&
      scrappedResume.education.length > 0
    ) {
      scrappedResume.education.map(async (edu) => {
        const educationId = uuid();
        let education: User_Education = {
          id: educationId,
          user_id: this.contractorUserId,
          title: edu.title ? edu.title : edu.accreditation.education,
          institution: edu.institution ? edu.institution : edu.organization,
          start_date: edu.start_date ? edu.start_date : edu.dates?.startDate,
          end_date: edu.end_date ? edu.end_date : edu.dates?.completionDate,
          summary: edu.summary,
          added_by_id: this.currentUserId,
          user: null,
        };
        educations.push(education);
      });
    }
    return educations;
  }

  get loading(): boolean {
    if (!this.resumeData) {
      return true;
    }
    return false;
  }
}
